<section id="profile" class="my-5">
    <div class="container">
        <div class="row justify-content-center">
            
                <input type="button" value="Add New Note..." class="p-2 pl-4 w-75 font-weight-bold text-left bg-transparent add_btn" data-toggle="modal" data-target="#addNote">
               
        
        </div>
        <div class="row " >
            <div class="col-md-3 my-5" *ngFor="let note of Notes">
                <div class="note shadow p-3 text-center" *ngIf="Notes[0]" >
                    <div class="row">
                        <div class="col-12">

                            <div class="dropdown">
                                <i class="fas fa-ellipsis-v float-right" role="button" id="dropdownMenuLink"
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></i>

                                <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                                    <a class="dropdown-item d-flex justify-content-between" data-toggle="modal"
                                        data-target="#editNote">
                                        <span class="text-left text-white"  (click)="saveID(note._id)" (click)="setCurNote(note.title,note.desc)">Edit Note</span>
                                        <i class="far fa-edit text-right text-white"></i>

                                    </a>
                                    <a class="dropdown-item d-flex justify-content-between ">
                                        <span class="text-left text-white " (click)="deleteNote(note._id)">delete Note</span>
                                        <i class="far fa-trash-alt text-right text-white "></i>
                                    </a>

                                </div>
                            </div>
                        </div>
                    </div>
                    <h3 class="text-left font-weight-bold">{{note.title}}</h3>
                    <p class="text-left">{{note.desc}}</p>
                </div>
            </div>
        </div>
    </div>
</section>

<!--Add Modal -->
<div class="modal fade" id="addNote" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <form [formGroup]="addForm">
                <div class="modal-header">
                    <h3 class="modal-title" id="exampleModalLabel">Hi {{decoded.first_name}},</h3>
                    <button type="button" class="close text-white" data-dismiss="modal"  (click)="reset()"  aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <input class="form-control mb-2" placeholder="Title" formControlName="title">
                    <textarea class="form-control" cols="50" rows="10" placeholder="Add your note..."
                    formControlName="desc"></textarea>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-success" (click)="addNote()" >Add</button>
                    <button type="button" class="btn btn-danger"  (click)="reset()"  data-dismiss="modal">Close</button>
                </div>
            </form>
        </div>
    </div>
</div>
<!-- End Modal -->


<!--update Modal -->
<div class="modal fade" id="editNote" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <form [formGroup]="editForm">
                <div class="modal-header">
                    <h3 class="modal-title" id="exampleModalLabel">Edit Your Note</h3>
                    <button type="button" class="close text-white" data-dismiss="modal" (click)="reset()" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <input class="form-control mb-2"  formControlName="title" placeholder="Title">
                    <textarea class="form-control" cols="50" rows="10"  formControlName="desc" placeholder="Edit Your Note"></textarea>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" (click)="updateNote()">Update</button>
                    <button type="button" class="btn btn-secondary" (click)="reset()" data-dismiss="modal">Close</button>
                </div>
            </form>
        </div>
    </div>
</div>
<!-- update Modal -->



